import React, {useLayoutEffect} from 'react';
import {
  View,
  Platform,
  ScrollView,
  TouchableWithoutFeedback,
  TextStyle,
  Linking,
} from 'react-native';
import {RNEText, SVGIcon, RNEButton} from '../../components';
import {SafeAreaView} from 'react-native-safe-area-context';

import {DrawerActions, useNavigation} from '@react-navigation/native';
import {NavigationKey} from '../../navigations/config';
import {NavigationTitle} from '../../navigations/config/navigationTitle';

import {makeStyles} from 'rne-netzon';
import {colorPalette} from '../../../core/config/color.config';

import {HeaderProfileLeft, HeaderProfileRight} from '../../views';

const DoctorVerificationLandingScreen = () => {
  const navigation = useNavigation();
  const sharedStyles = useSharedStyles();
  const webStyles = useWebStyles();
  const mobileStyles = useMobileStyles();

  const goToProfessionalProfile = () => {
    navigation.navigate(NavigationKey.DOCTOR_PROFILE_STACK, {
      screen: NavigationKey.DOCTOR_VIEW_PROFESSIONAL_PROFILE,
    });
  };

  const goToWebsite = (index: number) => {
    let url = '';

    switch (index) {
      case 0:
        url = 'http://housecall.com.ph/';
        break;
      case 1:
        url = 'https://www.facebook.com/House-Call-112923250497692';
        break;
      case 2:
        url = 'https://www.instagram.com/housecall.app/';
        break;
    }

    Linking.canOpenURL(url).then(supported => {
      if (supported) {
        Linking.openURL(url);
      } else {
        console.log('Cannot redirect to ' + url);
      }
    });
  };

  useLayoutEffect(() => {
    navigation.setOptions(
      Platform.OS === 'web'
        ? {
            headerShown: false,
            title: NavigationTitle.DOCTOR_SCREEN_LANDING,
          }
        : {
            headerShown: true,
            ...{
              headerStyle: {
                elevation: 0,
                shadowOpacity: 0,
              },
              headerTitleStyle: {
                fontWeight: 'bold',
                fontFamily: 'Quicksand-Bold',
                fontSize: 16,
              } as TextStyle,
            },
            headerStyle: {
              backgroundColor: colorPalette.purple,
              borderBottomColor: 'transparent',
              elevation: 0,
              shadowOpacity: 0,
            },
            headerTitleStyle: {
              paddingLeft: 28,
            },
            headerLeft: () => (
              <HeaderProfileLeft inProfileScreen={true} isLogoContrast={true} />
            ),
            headerRight: () => (
              <HeaderProfileRight
                showMessageIcon={false}
                isMenuLight={true}
                onClick={() =>
                  navigation.dispatch(DrawerActions.toggleDrawer())
                }
              />
            ),
            ...{
              title: '',
              headerTintColor: colorPalette.primary,
            },
          },
    );
  }, [navigation]);

  return (
    <SafeAreaView style={sharedStyles.root}>
      {Platform.OS === 'web' ? (
        <ScrollView>
          <View style={webStyles.mainContainer}>
            <View>
              <RNEText
                label="Hang in there, Doc!"
                variant="header"
                weight="bold"
                color="white"
              />
              <RNEText
                label="Your application is still on verification status. This process normally takes 24-48 hrs."
                variant="body"
                color="white"
                style={customWebTextFont}
                weight="300"
              />
            </View>
            <View style={webStyles.snsHeader}>
              <RNEText
                label="Meanwhile, you may visit our pages to get updates"
                variant="body"
                color="white"
                style={customWebTextFont}
                weight="300"
              />
            </View>
            <View style={sharedStyles.snsWrapper}>
              <TouchableWithoutFeedback onPress={() => goToWebsite(0)}>
                <View accessibilityRole="button" style={webStyles.snsContainer}>
                  <SVGIcon name="globe" size={32} />
                </View>
              </TouchableWithoutFeedback>
              <TouchableWithoutFeedback onPress={() => goToWebsite(1)}>
                <View accessibilityRole="button" style={webStyles.snsContainer}>
                  <SVGIcon name="facebook" size={32} />
                </View>
              </TouchableWithoutFeedback>
              <TouchableWithoutFeedback onPress={() => goToWebsite(2)}>
                <View accessibilityRole="button" style={webStyles.snsContainer}>
                  <SVGIcon name="instagram" size={32} />
                </View>
              </TouchableWithoutFeedback>
            </View>
            <View style={webStyles.buttonContainer}>
              <RNEButton
                title="Check my account"
                color="white"
                variant="outlined"
                height={48}
                onPress={goToProfessionalProfile}
              />
            </View>
          </View>
        </ScrollView>
      ) : (
        <ScrollView>
          <View style={mobileStyles.mainContainer}>
            <View>
              <RNEText
                label="Hang in there, Doc!"
                variant="header"
                weight="bold"
                color="white"
              />
              <RNEText
                label="Your application is still on verification status. This process normally takes 24-48 hrs."
                variant="body"
                color="white"
              />
            </View>
            <View style={mobileStyles.snsHeader}>
              <RNEText
                label="Meanwhile, you may visit our pages to get updates"
                variant="body"
                color="white"
              />
            </View>
            <View style={sharedStyles.snsWrapper}>
              <TouchableWithoutFeedback onPress={() => goToWebsite(0)}>
                <View
                  accessibilityRole="button"
                  style={mobileStyles.snsContainer}>
                  <SVGIcon name="globe" size={16} />
                </View>
              </TouchableWithoutFeedback>
              <TouchableWithoutFeedback onPress={() => goToWebsite(1)}>
                <View
                  accessibilityRole="button"
                  style={mobileStyles.snsContainer}>
                  <SVGIcon name="facebook" size={16} />
                </View>
              </TouchableWithoutFeedback>
              <TouchableWithoutFeedback onPress={() => goToWebsite(2)}>
                <View
                  accessibilityRole="button"
                  style={mobileStyles.snsContainer}>
                  <SVGIcon name="instagram" size={16} />
                </View>
              </TouchableWithoutFeedback>
            </View>
            <View style={mobileStyles.buttonContainer}>
              <RNEButton
                title="Check my account"
                color="white"
                variant="outlined"
                height={48}
                onPress={goToProfessionalProfile}
              />
            </View>
          </View>
        </ScrollView>
      )}
    </SafeAreaView>
  );
};

export default DoctorVerificationLandingScreen;

const customWebTextFont = {
  fontSize: 20,
};

const useSharedStyles = makeStyles({
  root: {
    height: '100%',
    flexDirection: 'row',
    alignItems: 'center',
    width: '100%',
    backgroundColor: colorPalette.purple,
  },
  snsWrapper: {
    width: '100%',
    flexDirection: 'row',
    marginTop: 24,
  },
});

const useWebStyles = makeStyles({
  mainContainer: {
    padding: 100,
    maxWidth: 720,
  },
  buttonContainer: {
    width: 200,
    marginTop: 86,
  },
  snsHeader: {
    marginTop: 48,
  },
  snsContainer: {
    justifyContent: 'center',
    alignItems: 'center',
    width: 80,
    height: 80,
    marginRight: 32,
    borderRadius: 100,
    backgroundColor: colorPalette.secondary,
  },
});

const useMobileStyles = makeStyles({
  mainContainer: {
    paddingVertical: 60,
    paddingHorizontal: 40,
  },
  buttonContainer: {
    width: 160,
    marginTop: 100,
  },
  snsHeader: {
    marginTop: 64,
  },
  snsContainer: {
    justifyContent: 'center',
    alignItems: 'center',
    width: 50,
    height: 50,
    marginRight: 20,
    borderRadius: 50,
    backgroundColor: colorPalette.secondary,
  },
});
